import { useAppDispatch, useAppSelector } from '../../../../lib/redux/hooks'
import { MadfarmInput } from '../../../../ui/molecules/input/newInput'
import { ProtocolSelectByObject } from '../../../../ui/molecules/ProtocolSelectByObj'
import { MadfarmStaticSelect } from '../../../../ui/molecules/select/newSelect/static'
import TextArea from '../../../../ui/molecules/textArea'
import { tipologiaRichiestaComplianceRequest } from '../../../../utils'
import { CustomersOtherOdCEdit } from '../components/extCustomers'
import { setEditRequestDescription, setEditRequestNote, setEditRequestProduct, setEditRequestProtocolId, setEditRequestSender, setEditRequestType } from '../slice'
import '../styles.scss'

export function EditFormRequest() {
    const dispatch = useAppDispatch()
    const sessionState = useAppSelector(state => state.session)
    const complianceRequestState = useAppSelector(state => state.complianceRequest)

    return (
        <div className="flex flex-col gap-6 p-4">
            <div className="rounded-xl border border-neutral-200 bg-white shadow-sm overflow-hidden">
                <div className="bg-brandPrimary-600 px-6 py-4">
                    <span className="text-white font-semibold text-lg">Richieste di Conformità / Richiesta</span>
                </div>
                <div className="p-6 flex flex-col gap-4">
                    <ProtocolSelectByObject
                        objectId='138'
                        error={complianceRequestState.complianceRequestErrors.requestProtocolId}
                        errorLabel='Inserire protocollo richiesta'
                        customerId={sessionState.selected.customerId!}
                        defaultValue={complianceRequestState.complianceRequestsUpdate.requestProtocolId}
                        value={complianceRequestState.complianceRequestsUpdate.requestProtocolId}
                        placeholder='Seleziona protocollo...'
                        type='entry'
                        onChange={(value) => dispatch(setEditRequestProtocolId(value))}
                    />
                    <MadfarmInput
                        label="Mittente"
                        placeholder="Mittente"
                        error={complianceRequestState.complianceRequestErrors.sender}
                        supportingText={complianceRequestState.complianceRequestErrors.sender ? 'Indicare Mittente' : undefined}
                        value={complianceRequestState.complianceRequestsUpdate.sender}
                        defaultValue={complianceRequestState.complianceRequestsUpdate.sender}
                        onChangeText={(text) => { dispatch(setEditRequestSender(text)) }}
                    />
                    <div className="border-[0.5px] border-neutral-200" />
                    <div className='grid grid-cols-2 gap-6'>
                        <MadfarmStaticSelect
                            noOptionsMessage=''
                            error={complianceRequestState.complianceRequestErrors.requestType}
                            errorLabel='Inserire protocollo richiesta'
                            label='Tipologia della Richiesta'
                            placeholder={'Seleziona Tipologia'}
                            options={tipologiaRichiestaComplianceRequest}
                            value={complianceRequestState.complianceRequestsUpdate.requestType}
                            onChange={(value) => {
                                //@ts-ignore
                                const newValue = value !== null ? value.value : null
                                dispatch(setEditRequestType(newValue))
                            }}
                        />
                        <MadfarmInput
                            label="Prodotto"
                            placeholder="Prodotto"
                            value={complianceRequestState.complianceRequestsUpdate.product}
                            defaultValue={complianceRequestState.complianceRequestsUpdate.product}
                            onChangeText={(text) => { dispatch(setEditRequestProduct(text)) }}
                        />
                    </div>
                    <div className="border-[0.5px] border-neutral-200" />
                    <CustomersOtherOdCEdit />
                    <TextArea
                        label='Descrizione Richiesta'
                        error={complianceRequestState.complianceRequestErrors.description}
                        supportingText={complianceRequestState.complianceRequestErrors.description ? 'Indicare Descrizione' : undefined}
                        defaultValue={complianceRequestState.complianceRequestsUpdate.description}
                        value={complianceRequestState.complianceRequestsUpdate.description}
                        onChangeText={(text) => { dispatch(setEditRequestDescription(text)) }}
                    />
                    <TextArea
                        label='Note'
                        defaultValue={complianceRequestState.complianceRequestsUpdate.note}
                        value={complianceRequestState.complianceRequestsUpdate.note}
                        onChangeText={(text) => { dispatch(setEditRequestNote(text)) }}
                    />
                </div>
            </div>
        </div>
    )
}